import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TimelineSectionProps } from "web_myplann/NotificationCenter/Types/TimelineSectionProps";

export const TimelineSectionFrame: FC<TimelineSectionProps> = ({
	title,
	muted = false,
	testId,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack
			data-testid={testId}
			bgcolor={theme.palette.grey[100]}
			sx={{ opacity: muted ? 0.6 : 1 }}
		>
			<Typography
				fontSize={11}
				fontWeight={600}
				color={muted ? theme.palette.text.secondary : theme.palette.grey[600]}
				textTransform="uppercase"
				letterSpacing={0.5}
				px={1.6}
				pt={1.2}
				pb={0.8}
			>
				{title}
			</Typography>
			<Box mb={1.2}>{children}</Box>
		</Stack>
	);
};
